import { Button, message } from "antd";
import { useEffect, useState, useMemo } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { useDispatch, useSelector } from "react-redux";
import ButtonAsLink from "../../../components/common/ButtonAsLink";
import BasicLayout from "../../../components/BasicLayout";
import FallBack from "../../../components/common/FallBack/FallBack";
import Tables from "../../../components/common/Table/Table";
import { useDeleteAction } from "../../../components/Hooks/useDeleteAction";
import useExportCsv from "../../../components/Hooks/useExportCsv";
import useTableSearch from "../../../components/Hooks/useTableSearch";
import { getCategories, softDeleteCategory } from "../../../store/actions/Careers/careers.action";
import { DeleteModel } from "../../../utils/DeleteModel";
import { formatFileName } from "../../../utils/helper";

const Index = (props) => {
	const dispatch = useDispatch();
	const [getColumnSearchProps] = useTableSearch();
	const [exportToCSV] = useExportCsv();
	const { deleteData } = useDeleteAction();
	const [deleteId, setDeleteId] = useState(undefined);
	const [isModalVisible, setIsModalVisible] = useState(false);
	const categories = useSelector((state) => state.careers.categories || []);

	const admin = useSelector((state) => state.admin.admin || {});

	const permissionArr = useMemo(() => {
		if (admin && admin.template) {
			const { permissions } = admin.template;
			return permissions;
		} else if (admin && admin.accessLevel === "superAdmin") {
			return "all";
		}
		return [];
	}, [admin]);

	useEffect(() => {
		dispatch(getCategories());
	}, [dispatch]);

	async function confirm(id, reason) {
		await deleteData(id, reason, softDeleteCategory, setIsModalVisible);
	}
	const columns = [
		{
			title: "Id",
			dataIndex: "id",
			key: "id",
		},
		{
			title: "Title",
			dataIndex: "title",
			key: "title",
			...getColumnSearchProps("title"),
		},
		{
			title: "Action",
			key: "action",
			render: (_text, record) => (
				<DeleteModel
					record={record}
					confirm={confirm}
					setIsModalVisible={setIsModalVisible}
					isModalVisible={isModalVisible}
					cancelMessage="Job category Removing has been cancelled"
					linkUrl={`/careers/categories`}
					placeholder="Please enter reason to delete Job category"
					deleteId={deleteId}
					setDeleteId={setDeleteId}
					update={
						permissionArr === "all"
							? "true"
							: permissionArr?.career?.categories.filter((item) => item === "update")?.length > 0
							? "true"
							: false
					}
					isdelete={
						permissionArr === "all"
							? "true"
							: permissionArr?.career?.categories.filter((item) => item === "delete")?.length > 0
							? "true"
							: false
					}
					view={
						permissionArr === "all"
							? "true"
							: permissionArr?.career?.categories.filter((item) => item === "read")?.length > 0
							? "true"
							: false
					}
				/>
			),
		},
	];
	const fileName = formatFileName("categories", "xlsx",admin);
	let dataSource = [];
	if (categories.length > 0) {
		dataSource = categories.sort(function (a, b) {
			return new Date(b.updatedAt) - new Date(a.updatedAt);
		});
		dataSource = dataSource.map((row, index) => ({
			...row,
			createdAt: new Date(row.createdAt).toLocaleString(),
			key: row.id,
		}));
	}
	const handleError = (error) => {
		message.error(error.message);
	};
	return (
		<BasicLayout accessLevel={props.accessLevel}>
			<ErrorBoundary FallbackComponent={FallBack} onError={handleError}>
				<div className="button-style-to-right">
					{permissionArr === "all" ? (
						<Button className="download-btn" onClick={(e) => exportToCSV(categories, fileName)}>
							Export
						</Button>
					) : permissionArr?.career?.categories?.filter((item) => item === "export")?.length > 0 &&
					  categories?.length !== 0 ? (
						<Button className="download-btn" onClick={(e) => exportToCSV(categories, fileName)}>
							Export
						</Button>
					) : null}

					{permissionArr === "all" ? (
						<ButtonAsLink text="Add New Category" link="/careers/categories/add" />
					) : permissionArr?.career?.categories?.filter((item) => item === "write")?.length > 0 ? (
						<ButtonAsLink text="Add New Category" link="/careers/categories/add" />
					) : null}
				</div>

				<Tables
					dataSource={dataSource}
					columns={columns}
					footerText={`Total Categories added: ${categories.length}`}
				/>
			</ErrorBoundary>
		</BasicLayout>
	);
};

export default Index;
